import OffersPro from "page/OffersPro";
import React from "react";
import formatUrl from "utils/FormatUrl";
import styles from "./styleCredit.module.css";
import Image from "next/image";

const CreditImmobilerHeader = (props) => {
  const serializers: any = {
    h1: (props) => <h1 style={{ color: "red" }} {...props} />,
    li: ({ children }) => <li className="special-list-item">{children}</li>,
  };

  return (
    <>
      <div className={styles.container}>
        <div
          className={styles.overlay_image}
          style={{ opacity: `${props.overlay}%` }}
        ></div>
        <img
          className={styles.backgroundImage}
          src={props.backgroundUrl}
          alt={props.title}
        />
        <Image
          unoptimized
          className={styles.backgroundImage}
          src={props.backgroundUrl}
          alt={props.title}
          fill
        />
        <div className={styles.inner}>
          <div className={styles.vertical_center}>
            {props.title && <h1 className={styles.title}>{props.title}</h1>}
            {props.subtitle && (
              <h2
                className={`${styles.subtitle} ${props.offersPro ? styles.subTitleOffer : ""
                  }`}
              >
                {props.subtitle}
              </h2>
            )}
            {props.secsubtitle && (
              <h2
                className={` ${styles.subtitle} ${props.offersPro ? styles.secSubTitleOffer : ""
                  }`}
              >
                {props.secsubtitle}
              </h2>
            )}
            {props.buttonText && (
              <div className={styles.divBtn}>
                <button className={styles.btn}>
                  <a
                    href={
                      props.offersPro
                        ? props.button_link
                        : formatUrl(props.button_link, props.lang)
                    }
                    target="_blank"
                  >
                    {props.buttonText}
                  </a>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CreditImmobilerHeader;
